import { FileDown } from "lucide-react";
import { Card, CardContent } from "../components/ui/Card";
import { useDownloads } from "../lib/hooks/useDownloads";

export function Downloads() {
  const { data: categories, isLoading, isError } = useDownloads();

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Downloads</h1>
        <p className="text-gray-600 mt-1">
          Club documents, forms, and race results
        </p>
      </div>

      {isLoading && (
        <div className="text-center py-12 text-gray-600">Loading downloads…</div>
      )}

      {isError && (
        <Card>
          <CardContent className="py-12 text-center text-gray-600">
            Something went wrong loading the downloads. Please try again later.
          </CardContent>
        </Card>
      )}

      {!isLoading && !isError && (!categories || categories.length === 0) && (
        <Card>
          <CardContent className="py-12 text-center text-gray-600">
            No download categories yet.
          </CardContent>
        </Card>
      )}

      {!isLoading && !isError && (categories?.length ?? 0) > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {categories?.map((category) => {
            const itemsWithUrl = (category.downloads ?? []).filter(
              (item): item is typeof item & { url: string } => !!item.url,
            );
            if (itemsWithUrl.length === 0) return null;
            return (
              <Card key={category._id} variant="elevated" className="flex flex-col">
                <CardContent className="p-5 flex flex-col flex-1">
                  <h2 className="text-lg font-semibold text-gray-900 mb-3 flex items-center gap-2">
                    <FileDown className="w-5 h-5 shrink-0 text-primary-600" />
                    {category.name}
                  </h2>
                  <ul className="list-none space-y-2 p-0 m-0 flex-1">
                    {itemsWithUrl.map((item) => (
                      <li key={item.name}>
                        <a
                          href={item.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary-600 hover:text-primary-700 hover:underline text-sm"
                        >
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
